import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsApp = (service?: string) => {
    let message = 'Olá! Gostaria de saber mais informações sobre os serviços da Clínica CIS.';
    
    if (service) {
      message = `Olá! Gostaria de agendar uma consulta de ${service}.`;
    }
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/5569992246189?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handlePilatesExperimental = () => {
    const message = 'Olá! Gostaria de agendar uma aula experimental de Pilates gratuita.';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/5569992246189?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            {/* Informações da Clínica */}
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/logo.png" alt="Clínica CIS" className="footer-logo-img" />
                <div className="logo-text">
                  <span className="logo-title">Clínica CIS</span>
                  <span className="logo-subtitle">Clínica Integrada de Saúde</span>
                </div>
              </div>
              <p className="footer-description">
                Cuidando da sua saúde e bem-estar com profissionalismo e dedicação. 
                Oferecemos tratamentos personalizados em fisioterapia, pilates, estética e massoterapia.
              </p>
              <div className="social-links">
                <a 
                  href="https://www.instagram.com/fisiopilates.jipa" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="https://www.facebook.com/fisioterapiaepilates1" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a 
                  href="tel:+5569992246189"
                  aria-label="Telefone"
                >
                  <i className="fas fa-phone"></i>
                </a>
                <button 
                  onClick={() => handleWhatsApp()}
                  aria-label="WhatsApp"
                  className="social-whatsapp"
                >
                  <i className="fab fa-whatsapp"></i>
                </button>
              </div>
            </div>

            {/* Links Rápidos */}
            <div className="footer-section">
              <h3 className="footer-title">Links Rápidos</h3>
              <ul className="footer-links">
                <li><Link to="/">Início</Link></li>
                <li><Link to="/servicos">Nossos Serviços</Link></li>
                <li><Link to="/sobre">Sobre Nós</Link></li>
                <li><Link to="/contato">Contato</Link></li>
                <li><Link to="/agendamento">Agendar Consulta</Link></li>
              </ul>
            </div>

            {/* Serviços */}
            <div className="footer-section">
              <h3 className="footer-title">Nossos Serviços</h3>
              <ul className="footer-links">
                <li>
                  <button onClick={() => handleWhatsApp('Fisioterapia')}>
                    Fisioterapia
                  </button>
                </li>
                <li>
                  <button onClick={() => handleWhatsApp('Pilates')}>
                    Pilates
                  </button>
                </li>
                <li>
                  <button onClick={() => handleWhatsApp('Estética')}>
                    Estética
                  </button>
                </li>
                <li>
                  <button onClick={() => handleWhatsApp('Massoterapia')}>
                    Massoterapia
                  </button>
                </li>
                <li>
                  <button onClick={handlePilatesExperimental} className="highlight-link">
                    <i className="fas fa-gift"></i>
                    Aula Experimental Pilates
                  </button>
                </li>
              </ul>
            </div>

            {/* Contato */}
            <div className="footer-section">
              <h3 className="footer-title">Contato</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <strong>Endereço:</strong>
                    <p>R. José Bezerra, 2033<br />Nova Brasília, Ji-Paraná - RO<br />CEP: 76908-466</p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="fas fa-phone"></i>
                  <div>
                    <strong>Telefone:</strong>
                    <p>
                      <a href="tel:+5569992246189">(69) 99224-6189</a><br />
                      <a href="tel:+5569994046340">(69) 99404-6340</a>
                    </p>
                  </div>
                </div>
                <div className="contact-item">
                  <i className="fas fa-clock"></i>
                  <div>
                    <strong>Horário:</strong>
                    <p>Segunda a Sexta: 7h às 20h<br />Sábado: 7h às 12h</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Rodapé inferior */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Clínica CIS. Todos os direitos reservados.</p>
            <div className="footer-bottom-links">
              <a href="#" onClick={(e) => e.preventDefault()}>Política de Privacidade</a>
              <a href="#" onClick={(e) => e.preventDefault()}>Termos de Uso</a>
              <Link to="/admin">Área Administrativa</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

